import { FormEvent, useEffect, useState } from 'react'
import { Col, Form, FormGroup, Input, Label } from 'reactstrap';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Btn, H2, Image, P } from '../AbstractElements';
import { dynamicImage } from '../Utils';
import { ConfirmPassword, EmailAddress, Password, ResetYourPassword } from '../Utils/Constants';
import { resetPassword } from '../Services/AuthService';
import { Eye, EyeOff } from 'lucide-react';

export default function ResetPasswordForm() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [isPasswordVisible, setPasswordVisible] = useState(false);
    const [isConfirmPasswordVisible, setConfirmPasswordVisible] = useState(false);
    const [hasInput, setHasInput] = useState(false);
    const [hasCInput, setHasCInput] = useState(false);
    const toggle = () => setPasswordVisible(!isPasswordVisible);
    const toggleConfirm = () => setConfirmPasswordVisible(!isConfirmPasswordVisible);
    const [samePassword, setSamePassword] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleSubmit = async(e: FormEvent) => {
        e.preventDefault()
        if(!samePassword){
            return;
        }
        setLoading(true)

        const data = {
            'email_address': email,
            'password': password,
            'confirm_password': confirmPassword,
        }

        try {
            const response: any = await resetPassword(data);
            toast.success(response.message || 'Password reset successful');
            navigate(`${process.env.PUBLIC_URL}/login`);
        } catch (err: any) {
            setLoading(false);
            toast.error(err.message || "Invalid email-address");
        }
    };

    useEffect(() => {
        setHasInput(password.length > 0);
        setHasCInput(confirmPassword.length > 0);

        if (password === confirmPassword && password.length > 0) {
            setSamePassword(true);
        } else {
            setSamePassword(false);
        }
    },[password, confirmPassword]);

    useEffect(() => {
        const emailAddress = searchParams.get("email_address");
        if (!emailAddress) {
            navigate(`${process.env.PUBLIC_URL}/forgot-password`);
        } else {
            setEmail(emailAddress);
        }
    }, [searchParams, navigate]);

    return (
        <div>
            <div>
                <div className='logo'>
                    <Image className="img-fluid for-light m-auto" src={dynamicImage(`logo/logo.png`)} alt="looginpage" />
                    <Image className="img-fluid for-dark" src={dynamicImage(`logo/logo.png`)} alt="looginpage" />
                </div>
            </div>
            <div className="login-main">
                <Form className="theme-form" onSubmit={handleSubmit}>
                    <H2 className="text-center">{ResetYourPassword}</H2>
                    <P className="text-center">{"Input a new password"}</P>
                    
                    <FormGroup>
                        <Col><Label>{EmailAddress}</Label></Col>
                        <Input type="email" defaultValue={email} placeholder='Enter your email-address' readOnly />
                    </FormGroup>

                    <FormGroup>
                        <Col><Label>{Password}</Label></Col>
                        <div className="form-input position-relative">
                            <Input type={isPasswordVisible ? 'text' : 'password'} placeholder='Eneter your password' defaultValue={password} onChange={(event) => setPassword(event.target.value)} name="login[password]" />
                            <div className='show-hide' onClick={toggle}>
                                {/* <span className={!isPasswordVisible ? 'show' : ''}></span> */}
                                {isPasswordVisible ? (
                                    <EyeOff size={20} color={hasInput ? 'white' : 'black'}  />
                                ) : (
                                    <Eye size={20} color={hasInput ? 'white' : 'black'}/>
                                )}
                            </div>
                        </div>
                    </FormGroup>

                    <FormGroup>
                        <Col><Label>{ConfirmPassword}</Label></Col>
                        <div className="form-input position-relative">
                            <Input type={isConfirmPasswordVisible ? 'text' : 'password'} placeholder='Eneter your password' defaultValue={confirmPassword} onChange={(event) => setConfirmPassword(event.target.value)} name="login[confirm_password]" />
                            <div className='show-hide' onClick={toggle}>
                                {/* <span className={!isPasswordVisible ? 'show' : ''}></span> */}
                                {isConfirmPasswordVisible ? (
                                    <EyeOff size={20} color={hasCInput ? 'white' : 'black'}  />
                                ) : (
                                    <Eye size={20} color={hasCInput ? 'white' : 'black'}/>
                                )}
                            </div>
                        </div>
                        {!samePassword && confirmPassword.length > 0 && (
                            <P className="text-danger mt-2">Passwords do not match.</P>
                        )}
                    </FormGroup>

                    <FormGroup className="mb-0 checkbox-checked">
                        <div className="text-end mt-3">
                            <Btn color='primary' className="w-100" block disabled={loading}> 
                                {loading ? (
                                    <>
                                        <i className="fa-solid fa-spinner fa-spin me-2"></i> Reseting Password
                                    </>
                                ) : 'Reset Password'}
                            </Btn>
                        </div>
                    </FormGroup>
                </Form>
            </div>
        </div>
    )
}